import { Validator } from '@vista-digital/validator';
import { BarcodeType, barcodeTypeValidator } from '../../../../subcomponents/barcode/types/type';
export const memberCardConfigValidatorSchema = {
    barcodeType: barcodeTypeValidator,
    showMemberPhoto: Validator.boolean()
};
export const memberCardConfigValidator = Validator.object(memberCardConfigValidatorSchema);
export const defaultMemberCardConfig = {
    barcodeType: BarcodeType.QrCode,
    showMemberPhoto: true
};
